<template>
  <div>
    <b-input placeholder="Comienza a buscar..."
        v-model="textSearch"
        icon="magnify"
        type="is-primary"
        size="is-medium"
        :icon-right="textSearch ? 'close': ''"
        icon-right-clickable
        @input="search"
        @icon-right-click="textSearch = null" expanded>
    </b-input>
    <div class="search-result" v-if="textSearch">
      <ul class="result-list">
        <li class="list-item" v-for="(item, index) in data" :key="`item-${index}`" @click="openDetails(item)">
          <horse-item-search :horse="item" v-if="item.type == 'horse'"></horse-item-search>
          <rider-item-search :rider="item" v-else></rider-item-search>
        </li>
        <li class="list-item has-text-centered" v-if="data.length === 0">
            <div class="list-item-content">
              <p>
                <b-icon
                icon="magnify">
              </b-icon><br>No se encontraron resultados
              </p>
            </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import SearchService from '@/services/SearchService'
import HorseItemSearch from '@/components/HorseItemSearch'
import RiderItemSearch from '@/components/RiderItemSearch'

export default {
  components: {
    HorseItemSearch,
    RiderItemSearch
  },
  data () {
    return {
      textSearch: null,
      data: [
        {
          name: 'Admirada',
          type: 'horse',
          icon: 'horseshoe'
        },
        {
          name: 'Allan Fernández',
          type: 'rider',
          icon: 'account'
        }
      ]
    }
  },
  methods: {
    openDetails (item) {
      if (item.type === 'horse') {
        this.router.push({ name: 'horses.detail', params: { id: item.id } })
      } else if (item.type === 'rider') {
        this.router.push({ name: 'riders.detail', params: { id: item.id } })
      }
      this.textSearch = null
    },
    async search () {
      this.data = []
      if (this.textSearch) {
        let params = {
          'results': 5,
          'search': this.textSearch
        }
        let response = await SearchService.search(params)
        this.data = response.data.data
      }
    }
  }
}
</script>
